
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active" @close="borrar" width="800px">
        <template #header>
          <h4 class="not-margin">
            Crear registro
          </h4>
        </template>

        <div class="con-form">
            <md-steppers>
                <md-step id="first" md-label="Información del prospecto">
                    <p class="vs-select__message vs-select__message--danger v-enter-to" v-if="errorFields.includes('telefonoF')">El teléfono del familiar es un campo obligatorio. Sin esta información, no podremos finalizar el registro. Por favor, asegúrate de proporcionarlo.</p>
                    <vs-row>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="institucion" class="labelInput">
                                    Institución
                                </label>
                                <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                                    <template #message-danger v-if="errorFields.includes('institucion')">
                                        Requerido
                                    </template>
                                    <template v-if="instituciones.length" autocomplete="off">
                                        <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="cicloEscolar" class="labelInput">
                                    Ciclo Escolar
                                </label>
                                <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" autocomplete="off">
                                    <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                        Requerido
                                    </template>
                                    <template v-if="ciclosEscolares.length" autocomplete="off">
                                        <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                                <div v-if="cicloEscolar != ''" @click="cicloEscolar = ''" class="tache">
                                    <i class="far fa-times-circle"></i>
                                </div>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="programa" class="labelInput">
                                    Programa
                                </label>
                                <vs-select filter :loading="loadingPrograma" class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="!programas.length" autocomplete="off">
                                    <template #message-danger v-if="errorFields.includes('programa')">
                                        Requerido
                                    </template>
                                    <template v-if="programas.length" autocomplete="off">
                                        <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="oferta" class="labelInput">
                                    Oferta de nuevo ingreso
                                </label>
                                <vs-select filter :loading="loadingOferta" class="aqui pt-0" id="oferta" placeholder="Seleccionar Oferta" :key="ofertaId" v-model="oferta" :disabled="!ofertas.length" autocomplete="off">
                                    <template #message-danger v-if="errorFields.includes('oferta')">
                                        Requerido
                                    </template>
                                    <template v-if="ofertas.length" autocomplete="off">
                                        <vs-option v-for="option in ofertas" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Escuela de procedencia
                                </label>
                                
                                <vs-input class="py-0" v-model="escuela" placeholder="Escuela de procedencia" @input="getEscuelasProcedencia()" @focus="focusEscuela()"/>
                                <div class="escuelaOpciones" v-if="mostrarOpciones && escuelaSearch[0]">
                                    <div v-for="(escuela, i) in escuelaSearch" :key="i" class="divisionLineas">
                                        <div class="mb-2">
                                            <p class="my-2" style="font-size: 0.7rem; opacity: 0.5"><strong>{{escuela.text}}</strong></p>
                                            <div v-for="opciones in escuela.opciones" :key="opciones.id" @click="selectEscuela(opciones)" style="cursor: pointer;" class="pl-2">
                                                <p><i v-if="opciones.cct">{{opciones.cct}} - </i>{{opciones.text}} <small>{{opciones.ciudad}}</small></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Canal
                                </label>
                                <vs-select
                                    filter
                                    class="pt-0"
                                    v-model="canal"
                                    placeholder="Canal"
                                    @input="getEnterado(canal)"
                                >
                                    <vs-option v-for="(opciones, i) in canales" :key="i" :label="opciones.text" :value="opciones.id">
                                        {{opciones.text}} 
                                    </vs-option>
                                    <template #message-danger v-if="errorFields.includes('enterado')">
                                        Requerido
                                    </template>
                                </vs-select>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    ¿Cómo se enteró?
                                </label>
                                <vs-select
                                    filter
                                    class="pt-0"
                                    v-model="enterado"
                                    placeholder="¿Cómo se enteró?"
                                    :key="enteradoId"
                                >
                                    <vs-option v-for="(opciones, i) in formaEnterado" :key="i" :label="opciones.text" :value="opciones.id">
                                        {{opciones.text}} 
                                    </vs-option>
                                    <template #message-danger v-if="errorFields.includes('enterado')">
                                        Requerido
                                    </template>
                                </vs-select>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Apellido paterno
                                </label>
                                <vs-input class="pt-0" v-model="apellido_paterno"  placeholder="Apellido paterno">
                                    <template #message-danger v-if="errorFields.includes('apellido_paterno')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela"  class="labelInput">
                                    Apellido materno
                                </label>
                                <vs-input class="pt-0" v-model="apellido_materno" placeholder="Apellido materno"  >
                                    <template #message-danger v-if="errorFields.includes('apellido_materno')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Nombre(s)
                                </label>
                                <vs-input class="pt-0" v-model="nombre" placeholder="Nombre(s)" >
                                    <template #message-danger v-if="errorFields.includes('nombre')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="sexo" class="labelInput">
                                    Sexo
                                </label>
                                <vs-select filter class="aqui pt-0" id="sexo" placeholder="Seleccionar sexo" v-model="sexo">
                                    <template #message-danger v-if="errorFields.includes('sexo')">
                                        Requerido
                                    </template>
                                    <template>
                                        <vs-option label="Masculino" value="masculino">
                                           Masculino
                                        </vs-option>
                                        <vs-option label="Femenino" value="femenino">
                                           Femenino
                                        </vs-option>
                                        <vs-option label="Sin definir" value="pordefinir">
                                           Sin definir
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </form>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Celular
                                </label>
                                <vs-input class="pt-0" v-model="celular" placeholder="celular"/>
                            </form>
                            <div v-if="celular != ''" @click="celular = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off" class="labelInput">
                                <label for="escuela">
                                    Teléfono
                                </label>
                                <vs-input class="px-0 pt-0" v-model="telefono" placeholder="Teléfono">
                                </vs-input>
                            </form>
                            <div v-if="telefono != ''" @click="telefono = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </vs-col>
                    </vs-row>
                </md-step>
                
                <md-step id="second" md-label="Crear familiar">
                    <vs-row>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="parentesco" class="labelInput">
                                    Parentesco
                                </label>
                                <vs-select class="pt-0" id="parentesco" placeholder="Parentesco" v-model="parentesco">
                                    <vs-option label="Padre" value="padre">
                                        Padre
                                    </vs-option>
                                    <vs-option label="Madre" value="madre">
                                        Madre
                                    </vs-option>
                                    <vs-option label="Hermano/a" value="hermano">
                                        Hermano/a
                                    </vs-option>
                                    <vs-option label="Abuelo/a" value="abuelo">
                                        Abuelo/a
                                    </vs-option>
                                    <vs-option label="Tío/a" value="tio">
                                        Tío/a
                                    </vs-option>
                                    <vs-option label="Otro" value="otro">
                                        Otro
                                    </vs-option>
                                </vs-select>
                            </form>
                            <div v-if="parentesco != ''" @click="parentesco = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Apellido paterno
                                </label>
                                <vs-input class="pt-0" v-model="apellido_paternoF" placeholder="Apellido paterno">
                                </vs-input>
                            </form>
                            <div v-if="apellido_paternoF != ''" @click="apellido_paternoF = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Apellido materno
                                </label>
                                <vs-input class="pt-0" v-model="apellido_maternoF" placeholder="Apellido materno">
                                </vs-input>
                            </form>
                            <div v-if="apellido_maternoF != ''" @click="apellido_maternoF = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Nombre(s)
                                </label>
                                <vs-input class="pt-0" v-model="nombresF" placeholder="Nombre(s)">
                                </vs-input>
                            </form>
                            <div v-if="nombresF != ''" @click="nombresF = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Correo
                                </label>
                                <vs-input class="pt-0" v-model="correoF" placeholder="Correo">
                                </vs-input>
                            </form>
                            <div v-if="correoF != ''" @click="correoF = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </vs-col>
                        <vs-col sm="12" lg="4">
                            <form autocomplete="off">
                                <label for="escuela" class="labelInput">
                                    Teléfono
                                </label>
                                <vs-input class="pt-0" v-model="telefonoF" placeholder="Teléfono">
                                </vs-input>
                                <p class="vs-select__message vs-select__message--danger v-enter-to" v-if="errorFields.includes('telefonoF')">Requerido</p>
                            </form>
                            <div v-if="telefonoF != ''" @click="telefonoF = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </vs-col>
                    </vs-row>

                </md-step>
                
                <md-step id="three" md-label="Vinculación con hermanos">
                    <form autocomplete="off">
                        <vs-input :loading="loadingSearch" v-model="findHermano" placeholder="Buscar" @input="getBuscador(findHermano)" class="px-0 pb-0">
                        </vs-input>
                        <div v-if="findHermano != ''" @click="findHermano = ''; hermano_id = ''" class="tache">
                            <i class="far fa-times-circle"></i>
                        </div>
                        <div style="background: #F2F3F4; padding: 1%;" v-if="sinInfo == true && findHermano.length >= 4">
                            No hay información
                        </div>
                        <div style="background: #F2F3F4; padding: 1%;"  v-if="showMinimo">
                            Al menos 4 letras
                        </div>
                        <div v-if="data[0] && ocultarOpciones == true " class="list-group listAlumno">
                            <div v-for="alumno in data" :key="alumno.id" @click="select(alumno.id)" class="list-group-item" style="cursor: pointer;">
                                <div>
                                    <p v-text="alumno.fullName" class="m-0"></p>
                                </div>
                            </div>
                        </div>
                        <vs-row class="mt-4" v-if="hermano_id != ''">
                            <vs-col class="mb-2" style="border: 1px solid #EAECEE; border-radius: 7px;" sm="12" lg="12" v-for="(familiar, i) in selected.familiares" :key="i">
                                <vs-row>
                                    <vs-col :style="'background:' + familiarColor[familiar.parentesco]['color']" sm="2" lg="2">
                                        <div class="parentesco" :style="'background:'+familiarColor[familiar.parentesco]['color']">
                                            <span class="text-uppercase"><strong>{{familiar.parentesco}}</strong></span>
                                        </div>
                                    </vs-col>
                                    <vs-col class="py-1 px-2"  sm="10" lg="10">
                                        <h6>{{familiar.fullName}}</h6>
                                        <div class="d-flex justify-content-between">
                                            <p class="mb-0"><i class="far fa-envelope mr-2"></i>{{familiar.correo}}</p>
                                            <p class="mb-0"><i class="fas fa-mobile-alt mr-2"></i>{{familiar.celular}}</p>
                                        </div>
                                    </vs-col>
                                </vs-row>
                            </vs-col>
                            <vs-col class="mb-2" style="border: 1px solid #EAECEE; border-radius: 7px;" sm="12" lg="12" v-for="(familiar, i) in selected.hermanos" :key="i">
                                <vs-row>
                                    <vs-col :style="'background:' + familiarColor['hermano']['color']" sm="2" lg="2">
                                        <div class="parentesco" :style="'background:'+familiarColor['hermano']['color']">
                                            <span class="text-uppercase"><strong>Hermano</strong></span>
                                        </div>
                                    </vs-col>
                                    <vs-col class="py-1 px-2"  sm="10" lg="10">
                                        <h6>{{familiar.apellido_paterno}} {{familiar.apellido_materno}} {{familiar.nombres}}</h6>
                                        <div class="d-flex justify-content-between">
                                            <p class="mb-0"><small>MATRÍCULA</small>{{familiar.matricula}}</p>
                                        </div>
                                    </vs-col>
                                </vs-row>
                            </vs-col>
                        </vs-row>
                    </form>
                </md-step>
            </md-steppers>
        </div>

        <template #footer>
          <div class="footer-dialog d-flex">
            <vs-button danger block @click="borrar()" style="width: 30%;">
              Cancelar
            </vs-button>
            <vs-button success class="ml-auto" block @click="postProspectosCrear()" style="width: 30%;">
              Aceptar
            </vs-button>
          </div>

        </template>
      </vs-dialog>
    </div>
</template>
<script>
import admisiones from '../../../../../api/requests/admisiones.js'
import vincular from './hermanos.vue'
import Axios from 'axios';
export default {
    props:[
      'value',
      'institucionSelect',
      'instituciones',
      'ciclo',
    ],
    data:() => ({
        active: false,
        institucion:'',
        institucionId: (new Date()).getTime(),
        loadingInstituto: false,
        cicloEscolar: '',
        ciclosEscolares: [],
        cicloId: (new Date()).getTime(),
        loadingCiclo: false,
        programa: '',
        programas: [],
        programaId: (new Date()).getTime(),
        loadingPrograma: false,
        oferta: '',
        ofertas: [],
        ofertaId: (new Date()).getTime(),
        loadingOferta: false,
        errorFields: [],
        enterado: '',
        enteradoId: (new Date()).getTime(),
        formaEnterado: [],
        canal: '',
        canales: [
            {id: 'redes-sociales', text: 'Redes sociales'},
            {id: 'impresos', text: 'Impresos'},
            {id: 'tradicionales', text: 'Tradicionales'},
            {id: 'otros', text: 'Otros'},

        ],
        apellido_paterno: '',
        apellido_materno: '',
        nombre: '',
        sexo: '',
        celular: '',
        telefono: '',
        escuelas: [],
        escuela: '',
        escuelaId:(new Date()).getTime(),
        // FAMILIAR
        parentesco: 'padre',
        apellido_paternoF: '',
        apellido_maternoF: '',
        nombresF: '',
        correoF: '',
        telefonoF: '',
        familiarColor:{
            "padre":{
                "color": "#3498DB"
            },
            "madre":{
                "color": "#F1948A"
            },
            "hermano":{
                "color": "#F7DC6F"
            }
        },
        // HERMANO 
        findHermano: '',
        message: 'Al menos 4 letras...',
        messageShow: false,
        data: [],
        hidden: true,
        loadingSearch: false,
        sinInfo: false,
        showMinimo: false,
        selected: {
            hermanos: [],
            familiares: [],
        },
        ocultarOpciones: false,
        hermano_id:'',
        escuelaSearch: [],
        escuelaIdSelect: '',
        mostrarOpciones: false
    }),
    components:{
        vincular
    },
    created(){
        // this.getEscuelasProcedencia()
    },
    methods:{
        getEnterado(tipo){
            this.enterado = ''
            this.formaEnterado = []
            if(tipo == 'redes-sociales'){
                this.formaEnterado = [
                    {'id': 1, 'text': 'Facebook'},
                    {'id': 5, 'text': 'Google Maps'},
                    {'id': 2, 'text': 'Instagram'},
                    {'id': 3, 'text': 'Twitter'},
                    {'id': 6, 'text': 'Whatsapp'},
                    {'id': 4, 'text': 'Youtube'},
                ]
            }
            if(tipo == 'impresos'){
                this.formaEnterado = [
                    {'id': 7, 'text': 'Flyers'},
                    {'id': 12, 'text': 'Invitaciones'},
                    {'id': 9, 'text': 'Lonas'},
                    {'id': 10, 'text': 'Pósters'},
                    {'id': 8, 'text': 'Trípticos'},
                    {'id': 11, 'text': 'Volantes'},
                ]
            }
            if(tipo == 'tradicionales'){
                this.formaEnterado = [
                    {'id': 15, 'text': 'Espectaculares'},
                    {'id': 14, 'text': 'Radio'},
                    {'id': 16, 'text': 'Sitio Web'},
                    {'id': 13, 'text': 'Tradicionales'},
                ]
            }
            if(tipo == 'tradicionales'){
                this.formaEnterado = [
                    {'id': 15, 'text': 'Espectaculares'},
                    {'id': 14, 'text': 'Radio'},
                    {'id': 16, 'text': 'Sitio Web'},
                    {'id': 13, 'text': 'Tradicionales'},
                ]
            }
            if(tipo == 'otros'){
                this.formaEnterado = [
                    {'id': 18, 'text': 'Convenios'},
                    {'id': 22, 'text': 'Display'},
                    {'id': 21, 'text': 'Mailing'},
                    {'id': 19, 'text': 'Open House'},
                    {'id': 17, 'text': 'Visitas'},
                    {'id': 20, 'text': 'Voz en voz'},
                ]
            }
            this.enteradoId = (new Date()).getTime()
        },
        borrar(){
            this.programa = ''
            this.institucion = this.institucionSelect
            this.cicloEscolar = this.ciclo
            this.enterado = ''
            this.oferta = ''
            this.escuela = ''
            this.apellido_paterno = ''
            this.apellido_materno = ''
            this.nombre = ''
            this.sexo = ''
            this.celular = ''
            this.telefono = ''
            this.parentesco = ''
            this.apellido_paternoF = ''
            this.apellido_maternoF = ''
            this.nombresF = ''
            this.correoF = ''
            this.telefonoF = ''
            this.findHermano = ''
            this.hermano_id = ''
            this.active = false
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.loadingCiclo = true
                const { data: response } = await admisiones.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
        },
        async getProgramaProspecto() {
            if(this.institucion){
                this.loadingPrograma = true
                const { data: response } = await admisiones.getProgramaProspecto(this.institucion)
                this.programas = response
                this.programaId = (new Date()).getTime()
                this.loadingPrograma = false
            }
        },
        async getOfertaPrograma() {
            if(this.programa){
                this.loadingOferta = true
                const { data: response } = await admisiones.getOfertaPrograma(this.programa, this.cicloEscolar)
                this.ofertas = response
                this.ofertaId = (new Date()).getTime()
                this.loadingOferta = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.programa) {
                this.errorFields.push('programa')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.oferta) {
                this.errorFields.push('oferta')
            }
            if (!this.enterado) {
                this.errorFields.push('enterado')
            }
            if (!this.apellido_paterno) {
                this.errorFields.push('apellido_paterno')
            }
            if (!this.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.sexo) {
                this.errorFields.push('sexo')
            }
            if(this.apellido_maternoF != '' || this.apellido_paternoF != '' || this.nombresF != '' || this.correoF != ''){
                if(!this.telefonoF){
                    this.errorFields.push('telefonoF')
                }
            }
            if (!this.errorFields.length){
                const params = {
                    institucion_id: this.institucion.toString(),
                    programa_id: this.programa.toString(),
                    oferta_academica_id: this.oferta.toString(),
                    como_se_entero_id: this.enterado,
                    apellido_materno: this.apellido_materno,
                    apellido_paterno: this.apellido_paterno,
                    nombres: this.nombre,
                    sexo: this.sexo,
                    familiar_parentesco: this.parentesco,
                    hermano_id: this.hermano_id,
                    ciclo_escolar_id: this.cicloEscolar.toString()
                }
                    if(this.celular != ''){
                        params.celular = this.celular
                    }
                    if(this.escuela != ''){
                        params.escuela_procedencia_id = this.escuelaIdSelect
                    }
                    if(this.extension != ''){
                        params.extension = this.extension
                    }
                    if(this.apellido_maternoF != ''){
                        params.familiar_apellido_materno = this.apellido_maternoF
                    }
                    if(this.apellido_paternoF != ''){
                        params.familiar_apellido_paterno = this.apellido_paternoF
                    }
                    if(this.correoF != ''){
                        params.familiar_correo = this.correoF
                    }
                    if(this.nombresF != ''){
                        params.familiar_nombres = this.nombresF
                    }
                    if(this.parentesco != ''){
                        params.familiar_parentesco = this.parentesco
                    }
                    if(this.telefonoF != ''){
                        params.familiar_telefono = this.telefonoF
                    }
                    if(this.telefono != ''){
                        params.telefono = this.telefono
                    }
                return params
            } else {
                return null
            }
        },
        async postProspectosCrear(){
            const payload = this.sanityForm()
            if(payload){
                const loading = this.$vs.loading()
                try{
                    const { data: response } = await admisiones.postProspectosCrear(payload)
                    loading.close()

                    this.$emit('refreshTable', this.institucion, this.cicloEscolar, this.oferta)
                    this.borrar()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'El registro se creo correctamente.'
                    })

                }catch{
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salio mal',
                        text: 'Favor de contactar al administrador.'
                    })
                }
            }
        },
        getBuscador(info){
            if(info.length >= 4){
                this.loadingSearch = true
                this.sinInfo = false
                this.showMinimo = false
                Axios.get('/prospectos/findBrother', {params: {text: info}}).then(res => {
                    this.ocultarOpciones = true
                    this.hidden = false
                    this.data = res.data;
                    if(this.data[0]){
                    }else{
                        this.sinInfo = true
                    }
                    this.loadingSearch = false
                }).catch(e => {
                    this.ocultarOpciones = false
                    this.sinInfo = false
                    this.loadingSearch = false
                    if(this.$store.state.debug) {
                        toastr["error"](e, 'Error al buscar otros alumnos');
                    }
                });
            }else{
                this.showMinimo = true
            }
        },
        select(id) {
            this.hermano_id = id;
            this.ocultarOpciones = false
            Axios.get('/prospectos/findFamily', {params: {id: id}}).then(res => {
                this.selected = res.data;
                this.text = '';
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 'Error al buscar la relación familiar');
                }
            });
        },
        async getEscuelasProcedencia() {
            if(this.escuela.length >= 4){
                try{
                    const params = {
                        buscar: this.escuela
                    }
                    const { data: response } = await admisiones.getEscuelasProcedencia(params)
                    // this.escuelas = response
                    this.escuelaSearch = response
                    this.escuelaId = (new Date()).getTime()
                    this.mostrarOpciones = true
                }catch{

                }
            }
        },
        focusEscuela(){

            if(this.escuelaSearch[0] && this.escuela != ''){
                this.mostrarOpciones = true
            }
        },
        selectEscuela(info){
            this.escuelaIdSelect = info.id
            this.escuela = info.text + ' (' + info.ciudad + ')'
            this.mostrarOpciones = false
        }
    },
    watch:{
        value (val) {
            this.active = val
            this.institucion = this.institucionSelect
            this.cicloEscolar = this.ciclo
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        institucion(){
            this.getCicloEscolar()
            this.getProgramaProspecto()
        },
        programa(){
            this.getOfertaPrograma()
        },
        escuela(){
            this.mostrarOpciones = false
            this.escuelaSearch = []
        }
    }
}
</script>

<style>
.listAlumno{
    height: 200px;
    overflow: auto;
}
.listAlumno::-webkit-scrollbar {
    -webkit-appearance: none;
}

.listAlumno::-webkit-scrollbar:vertical {
    width:10px;
}

.listAlumno::-webkit-scrollbar-button:increment,.listAlumno::-webkit-scrollbar-button {
    display: none;
} 

.listAlumno::-webkit-scrollbar:horizontal {
    height: 10px;
}

.listAlumno::-webkit-scrollbar-thumb {
    background-color: #c0c0c0;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.listAlumno::-webkit-scrollbar-track {
    border-radius: 10px;  
}

.listAlumno .list-group-item{
    padding: 0 !important;   
    padding: 1% !important; 
}

.parentesco{
    height: 50px; 
    display: flex; 
    justify-content: center;
    align-items: center; 
    color: white;
}
</style>

<style lang="scss" scoped>

    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 2.5em);
            background: #F4F7F8;
        }

    }

    .escuelaOpciones{
        padding: 0 11px 10px 11px;
        position: absolute;
        z-index: 9;
        height: 150px;
        overflow-y: auto;
        box-shadow: 0px -10px 20px -5px rgba(0, 0, 0, var(--vs-shadow-opacity));
        background: white;
    }
    /* Estilos para motores Webkit y blink (Chrome, Safari, Opera... )*/

.escuelaOpciones::-webkit-scrollbar {
    -webkit-appearance: none;
}

.escuelaOpciones::-webkit-scrollbar:vertical {
    width:10px;
}

.escuelaOpciones::-webkit-scrollbar-button:increment,.escuelaOpciones::-webkit-scrollbar-button {
    display: none;
} 

.escuelaOpciones::-webkit-scrollbar:horizontal {
    height: 10px;
}

.escuelaOpciones::-webkit-scrollbar-thumb {
    background-color: #9c9c9c;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.escuelaOpciones::-webkit-scrollbar-track {
    border-radius: 10px;  
}
.divisionLineas:not(:last-child){
    border-bottom: 1px solid #E5E7E9; 
}
.divisionLineas{
    padding: 2% 0;
}

</style>